export class Language {
    constructor(
        public Code: string,
        public Name: string,
        public CountryCode: string
    ) { }
}
